import { shuffle, uniq } from 'lodash'

export const footerItems = [
  {
    text: 'Create Test',
    prompt: 'Help me create a test',
    icon:
      '<svg width="18" height="18" viewBox="0 0 19.329 25.682" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5,25.681H.828A.866.866,0,0,1,0,24.843V3.628a.86.86,0,0,1,.828-.837h3.59V2.513a.866.866,0,0,1,.828-.838H7a2.96,2.96,0,0,1,5.332,0h1.752a.866.866,0,0,1,.828.838v.279H18.5a.865.865,0,0,1,.828.837V24.843A.866.866,0,0,1,18.5,25.681ZM1.45,4.34V24.049H17.88V4.34H15.047v.844a.881.881,0,0,1-.85.845H5.132a.881.881,0,0,1-.849-.845V4.34Zm4.625-.991V4.466h7.18V3.349H11.8a.851.851,0,0,1-.8-.636,1.381,1.381,0,0,0-2.675,0,.85.85,0,0,1-.8.636Z" transform="translate(0 0)" fill="currentColor"/><rect width="1.526" height="8.016" rx="0.763" transform="translate(9.156 10.02)" fill="currentColor"/><rect width="1.526" height="8.016" rx="0.763" transform="translate(5.911 14.792) rotate(-90)" fill="currentColor"/></svg>',
  },
  {
    text: 'Analyze Data',
    prompt: 'Help me analyze my assessment data',
    icon:
      '<svg width="18" height="18" viewBox="0 0 23.918 21.125" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0)"><g transform="translate(0 0)"><g transform="translate(0 6.906)"><g transform="translate(0 0)"><path d="M156.7,150h-6.026a.679.679,0,0,0-.677.677v12.865a.679.679,0,0,0,.677.677H156.7a.679.679,0,0,0,.677-.677V150.677A.679.679,0,0,0,156.7,150Zm-.745,12.865h-4.6V151.354h4.6Z" transform="translate(-150 -150)"/></g></g><g transform="translate(8.248 0)"><g transform="translate(0 0)"><path d="M305.7,48h-6.026a.679.679,0,0,0-.677.677V68.449a.679.679,0,0,0,.677.677H305.7a.679.679,0,0,0,.677-.677V48.677A.679.679,0,0,0,305.7,48Zm-.677,19.771h-4.672V49.354h4.672Z" transform="translate(-299 -48)"/></g></g><g transform="translate(16.537 11.646)"><g transform="translate(0 0)"><path d="M6.7,220H.677a.679.679,0,0,0-.677.677V228.8a.679.679,0,0,0,.677.677H6.7a.679.679,0,0,0,.677-.677v-8.125A.679.679,0,0,0,6.7,220Zm-.677,8.125H1.354v-6.771H6.026Z" transform="translate(0 -220)"/></g></g></g></g></svg>',
  },
  {
    text: 'Find Items',
    prompt: 'Help me find items for my assessment',
    icon:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/><path d="M16 16l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  },
]

/** parent shuffles and passes 3 preprompts to Peary iframe. */
export const preprompts = [
  'How do I assign a test?',
  'Show me assignment settings',
  'What does "In Grading" mean?',
  'How do I enable anti-cheating?',
  'How do I reopen an assignment?',
  'Take me to Assignments',
  'How do I assign to multiple classes?',
  'What assignment types are available?',
  'Take me to Whole Learner Report',
  'Where can I view student progress?',
  'How do I open Live Class Board?',
  'Show me reports available in PA',
  'How do I compare student performance?',
  'Where do I see class results?',
  'Create a 5-question math test',
  'Create a quiz on fractions',
  'How do I create a test?',
  'How do I add standards?',
  'Show me my test library',
  'How do I share a test?',
  'How do I duplicate a test?',
  'Where can I edit my test?',
  'Take me to Manage Classes',
  'How do I create a class?',
  'How do I add students?',
  'Where can I manage roster sync?',
  'What can Peary help me do?',
  "What's new in Pear Assessment?",
  'Show me popular teacher workflows',
  'How do I get started?',
]

export const PREPROMPT_DISPLAY_COUNT = 3

/**
 * Returns `count` distinct random strings from `source` (without replacement).
 * Returns [] when there are fewer than `count` non-empty entries.
 */
export const pickRandomPreprompts = (source, count) => {
  const validPrePrompts = uniq(
    source
      .filter((s) => typeof s === 'string' && s.trim() !== '')
      .map((s) => s.trim())
  )
  if (validPrePrompts.length < count || count <= 0) {
    return []
  }
  return shuffle(validPrePrompts).slice(0, count)
}
